import type { StaticTextResource } from '../keys'

export const th: StaticTextResource = {
  'schedule.dueToday': 'ภายใน {{time}} วันนี้',
  'schedule.dueTomorrow': 'ภายใน {{time}} พรุ่งนี้',
  'schedule.durationRange':
    '{{start}} - {{end}} (วันที่ {{currentDay}} / {{days}} วัน)',
  'editReport.defaultPageName': 'หน้า {{n}}',
  'editReport.defaultSectionName': 'ส่วน',
  'editReport.defaultRepeatSectionName': 'ส่วนที่ทำซ้ำ',
}
